import { CurrencyConvertor } from '~/components/utils/formatters';

const formatEarnings = (earnings?: number) => {
  if (!earnings) {
    return CurrencyConvertor(0).replace('US', '');
  }

  return CurrencyConvertor(earnings).replace('US', '');
};

export default formatEarnings;
